var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7A3CA85B-CB16-4DCB-BB77-2DDE3B4C2155") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.06199348,11.0001 C4.51323989,7.38137753 7.38137753,4.51323989 11.0001,4.06199348 L11.0001,2.0001 L13.0001,2.0001 L13.0001,4.06199348 C16.6188225,4.51323989 19.4869601,7.38137753 19.9382065,11.0001 L22.0001,11.0001 L22.0001,13.0001 L19.9382065,13.0001 C19.4869601,16.6188225 16.6188225,19.4869601 13.0001,19.9382065 L13.0001,22.0001 L11.0001,22.0001 L11.0001,19.9382065 C7.38137753,19.4869601 4.51323989,16.6188225 4.06199348,13.0001 L2.0001,13.0001 L2.0001,11.0001 L4.06199348,11.0001 Z M18.0001,12.0001 C18.0001,8.68638475 15.3138153,6.0001 12.0001,6.0001 C8.68638475,6.0001 6.0001,8.68638475 6.0001,12.0001 C6.0001,15.3138153 8.68638475,18.0001 12.0001,18.0001 C15.3138153,18.0001 18.0001,15.3138153 18.0001,12.0001 Z M12.0001,9.0001 C13.6571,9.0001 15.0001,10.3431 15.0001,12.0001 C15.0001,13.6571 13.6571,15.0001 12.0001,15.0001 C10.3431,15.0001 9.0001,13.6571 9.0001,12.0001 C9.0001,10.3431 10.3431,9.0001 12.0001,9.0001 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Sixtbook_dashboard",
    transform: "translate(-22.000000, -524.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_location",
    transform: "translate(20.000000, 522.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#ffffff",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLocation);
export default __webpack_public_path__ + "static/media/ico_location.76ca222fbfffca1e01af76e9247795e7.svg";
export { ForwardRef as ReactComponent };